
import { Component, Vue } from 'vue-property-decorator';
import { redirectToEcommerce } from '../../helpers/eCommerce';

@Component
export default class CallbackWooCommerce extends Vue {
  get success(): string | null {
    return this.$route.query.success as string;
  }

  async mounted() {
    if (this.success === null || this.success === undefined) return;

    redirectToEcommerce(this.success === '1');
  }
}
